"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var gatsby_1 = require("gatsby");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var react_2 = require("@emotion/react");

var util_1 = require("../common/util");

var frontend_common_1 = require("@ryerson/frontend.common");

var Menu_models_1 = require("../common/Menus/Menu.models");

var Menu_data_1 = require("../common/Menus/Menu.data");

var Menu_content_1 = require("../common/Menus/Menu.content");

var StyledComponents_1 = require("../Renderers/StyledComponents");

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var MyAccountMenu = function MyAccountMenu(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      isMobile = _ref.isMobile,
      handleClose = _ref.handleClose,
      openMyAccountMenu = _ref.openMyAccountMenu,
      isSticky = _ref.isSticky,
      storeDirectory = _ref.storeDirectory;

  var _a;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      axiosInstance = _ref3.axiosInstance,
      _ref3$user$token = _ref3.user.token,
      token = _ref3$user$token === void 0 ? "" : _ref3$user$token,
      language = _ref3.localization.language,
      logout = _ref3.logout,
      profile = _ref3.profile,
      user = _ref3.user,
      setUser = _ref3.setUser;

  var _ref4 = (0, frontend_e_commerce_1.useEcommerce)(),
      resetAllCheckoutInformation = _ref4.resetAllCheckoutInformation,
      setDefaultShipToAddress = _ref4.setDefaultShipToAddress,
      setShipToAddresses = _ref4.setShipToAddresses;

  var _react_1$default$useS = react_1.default.useState(),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hasMounted = _react_1$default$useS2[0],
      setHasMounted = _react_1$default$useS2[1];

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      lighterGray = _theme$colors$primary.lighterGray,
      primaryBrand = _theme$colors$primary.primaryBrand,
      lightGray = _theme$colors$primary.lightGray,
      darkGray = _theme$colors$primary.darkGray,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      disable = _theme$colors$primary.disable;
  var red = theme.colors.secondary.red;

  var _ref5 = (0, react_1.useState)([]),
      _ref6 = _slicedToArray(_ref5, 2),
      menuList = _ref6[0],
      setMenuList = _ref6[1];

  var _ref7 = (0, react_1.useState)([]),
      _ref8 = _slicedToArray(_ref7, 2),
      menuFooter = _ref8[0],
      setMenuFooter = _ref8[1];

  var _ref9 = (0, react_1.useState)(profile && profile.groups.length > 1 || false),
      _ref10 = _slicedToArray(_ref9, 1),
      multiAccount = _ref10[0];

  var _ref11 = (0, react_1.useState)(function () {
    var currVal = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.myAccountActive);
    return currVal === "true" ? true : false;
  }),
      _ref12 = _slicedToArray(_ref11, 2),
      isActive = _ref12[0],
      setIsActive = _ref12[1]; // "More" Button Config


  var menuMoreButton = {
    id: "more-button",
    icon: "ellipsis-h",
    label: "More",
    active: false
  }; // Build Menu List Items from Default Menu & Based on Permission

  function buildMenuList(userToken) {
    var defaultMenuList = [];

    var _iterator = _createForOfIteratorHelper(Menu_data_1.myAccountMenuDefaultItems),
        _step;

    try {
      var _loop = function _loop() {
        var id = _step.value;
        var foundItem = Menu_data_1.accountMenuData.find(function (item) {
          return item.id === id;
        });
        var isEnabled = foundItem;
        var permission = foundItem && (0, util_1.checkMenuItemPermission)(foundItem.id, userToken);
        foundItem && isEnabled && permission && defaultMenuList.push(foundItem);
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return defaultMenuList;
  } //Build Menu List Footer Items from Default Menu Items & Filter Items Based on Permission


  function buildFooterList(userToken) {
    var defaultFooterList = [];

    var _iterator2 = _createForOfIteratorHelper(Menu_data_1.myAccountFooterDefaultItems),
        _step2;

    try {
      var _loop2 = function _loop2() {
        var id = _step2.value;
        var foundItem = Menu_data_1.accountMenuData.find(function (itm) {
          return itm.id === id;
        });
        var permission = foundItem && (0, util_1.checkMenuItemPermission)(foundItem.id, userToken);
        foundItem && permission && defaultFooterList.push(foundItem);
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return defaultFooterList;
  }

  var translate = function translate(label) {
    return Menu_content_1.withTranslation[label][language];
  };

  react_1.default.useEffect(function () {
    setHasMounted(true);
  }, []);
  (0, react_1.useEffect)(function () {
    if (hasMounted) {
      setMenuList(buildMenuList(token));
      setMenuFooter(buildFooterList(token));
    }
  }, [hasMounted, language, token]);
  (0, react_1.useEffect)(function () {
    if (openMyAccountMenu === true) {
      setIsActive(true);
      sessionStorage.setItem(frontend_common_1.SessionItems.myAccountActive, "true");
    } else {
      setIsActive(false);
      sessionStorage.setItem(frontend_common_1.SessionItems.myAccountActive, "false");
    }
  }, [openMyAccountMenu]);

  var openSwapAccountModal = function openSwapAccountModal() {
    if (profile && profile.groups.length > 1) {
      handleClose(true, true);
    }
  };

  var onLogoutClick = function onLogoutClick() {
    logout();
    resetAllCheckoutInformation();
    (0, gatsby_1.navigate)((0, util_1.getUrl)("/"));
    handleClose(true, false);
  };

  var getActiveProfile = function getActiveProfile() {
    var activeProfile = profile.groups.filter(function (group) {
      return group.locationNumber === user.account;
    });
    return activeProfile.length ? activeProfile : profile.groups;
  };
  /**
   * @describe Used in two scenarios
     --  get url to to go to magenium admin portal
      -- get access (jwt) token for exit shadow mode
   **/


  var getAPIData = function getAPIData(url, successCallback, errorCallBack) {
    axiosInstance.post(url, {}, {}).then(function (response) {
      var _ref13 = response || {},
          _ref13$status = _ref13.status,
          status = _ref13$status === void 0 ? "" : _ref13$status,
          _ref13$data = _ref13.data,
          data = _ref13$data === void 0 ? "" : _ref13$data;

      if (status === 200) {
        successCallback && successCallback(data);
      } else {
        throw new Error("".concat(status));
      }
    }).catch(function (error) {
      console.error("~Error", error);
      errorCallBack && errorCallBack(error);
    });
  };

  var setUserWithToken = function setUserWithToken(jwt) {
    (0, frontend_application_1.setLoggedInUser)(jwt, setUser);
  };

  var onMenuItemClick = function onMenuItemClick(event, item) {
    var id = item.id,
        url = item.url,
        active = item.active,
        label = item.label;

    switch (true) {
      case id === Menu_models_1.AccountMenuItemId.logOut:
        onLogoutClick();
        break;

      case id === Menu_models_1.AccountMenuItemId.switchAccounts:
        handleClose(true, true);
        break;

      case id === Menu_models_1.AccountMenuItemId.adminPortal:
        event.preventDefault();
        getAPIData(frontend_common_1.ApiUrl.MAGENIUM_PORTAL, function (targetUrl) {
          return window.location = targetUrl;
        });
        handleClose(true);
        break;

      case id === Menu_models_1.AccountMenuItemId.exitShadowMode:
        event.preventDefault();
        getAPIData(frontend_common_1.ApiUrl.EXIT_SHADOW_MODE, function (jwt) {
          setUserWithToken(jwt);
          setMenuList(buildMenuList(jwt));
          setMenuFooter(buildFooterList(jwt));
          setDefaultShipToAddress({});
          setShipToAddresses([]);
          handleClose(true);
        });
        handleClose(true);
        break;

      case id === "more-button":
        // TODO: handle more button
        break;

      default:
        if (active && !!(url.length > 0)) {
          if (window === null || window === void 0 ? void 0 : window.sessionStorage) {
            var currWindowPath = url === null || url === void 0 ? void 0 : url.replace(/\/+$/, "").split("/").pop();
            var existingPagePath = window === null || window === void 0 ? void 0 : window.sessionStorage.getItem("pageLocation");
            existingPagePath !== currWindowPath && sessionStorage.setItem("pageLocation", currWindowPath);
          }

          (0, util_1.navigateLink)(storeDirectory, url);
        } else {
          console.error("*disabled-item", label);
        }

        break;
    }
  };

  var okToRenderFooterItem = function okToRenderFooterItem(itemId) {
    if (itemId === Menu_models_1.AccountMenuItemId.switchAccounts && profile.groups.length === 1) {
      return false;
    } else {
      return true;
    }
  };

  var renderMenuItem = function renderMenuItem(item, index) {
    var menuItemDisabled = item.active === false;
    var menuItemColor = menuItemDisabled ? disable : item.id === Menu_models_1.AccountMenuItemId.exitShadowMode ? red : "inherit";
    var hoverColor = menuItemDisabled ? disable : primaryBrand;
    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: "my-account-menu-item-".concat(index),
      onClick: function onClick(e) {
        return !menuItemDisabled && onMenuItemClick(e, item);
      },
      alignItems: "center",
      style: (0, StyledComponents_1.menuItemStyles)(menuItemColor, hoverColor, menuItemDisabled),
      children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
        size: "xs",
        icon: item.icon,
        color: item.id === Menu_models_1.AccountMenuItemId.exitShadowMode ? red : lightGray
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        css: {
          marginLeft: 20
        },
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: isMobile ? "md" : "sm",
          variant: "div",
          css: (0, StyledComponents_1.menuItemText)(menuItemColor, hoverColor, menuItemDisabled),
          children: translate(item.id)
        })
      })]
    }, "my-account-menu-item-".concat(index));
  };

  return (0, jsx_runtime_1.jsx)("div", {
    css: (0, StyledComponents_1.mainContainerStyles)({
      isActive: isActive,
      breakpoint: theme.breakpoints.lg
    }),
    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      css: {
        width: "100%"
      },
      children: profile && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        className: className,
        direction: isMobile ? "column" : "row",
        style: (0, StyledComponents_1.myAccountWrapper)({
          background: lighterGray
        }),
        children: [!isMobile && (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          className: "my-account-menu-inner",
          css: {
            width: 250,
            backgroundColor: white
          },
          children: [(0, jsx_runtime_1.jsxs)(StyledComponents_1.YourAccountWrapper, {
            children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              variant: "h4",
              weight: "bolder",
              css: StyledComponents_1.yourAccountText,
              children: translate("Your Account")
            }), profile && (0, jsx_runtime_1.jsxs)("div", {
              onClick: openSwapAccountModal,
              css: (0, StyledComponents_1.accountLink)({
                color: multiAccount ? primaryBrand : secondaryBrand,
                cursor: multiAccount ? "pointer" : "default"
              }),
              "data-testid": "my-account-menu-link",
              children: [" ", (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                justifyContent: "space-between",
                children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "sm",
                  color: secondaryBrand,
                  children: multiAccount ? getActiveProfile()[0].locationName : (_a = profile === null || profile === void 0 ? void 0 : profile.customer) === null || _a === void 0 ? void 0 : _a.companyName
                })
              }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                size: "sm",
                color: secondaryBrand,
                children: function () {
                  var _a;

                  var val = multiAccount ? getActiveProfile()[0].locationNumber : (_a = profile === null || profile === void 0 ? void 0 : profile.customer) === null || _a === void 0 ? void 0 : _a.customerNumber;
                  return val ? "(".concat(val, ")") : "";
                }()
              })]
            })]
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
            color: darkGray
          })]
        }), isMobile && (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
          children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            justifyContent: "flex-end",
            style: (0, StyledComponents_1.closeButtonWrapper)({
              color: darkGray,
              isMobile: isMobile
            }),
            children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              justifyContent: "center",
              alignItems: "center",
              style: (0, StyledComponents_1.closeButton)({
                color: white,
                isMobile: isMobile
              }),
              onClick: function onClick() {
                return handleClose(true);
              },
              dataTestId: "my-account-menu-mobile-close",
              children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                icon: "close",
                size: "sm",
                onClick: function onClick() {
                  return handleClose(true);
                },
                color: white
              })
            })
          }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
            style: (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tmargin: 0 25px;\n\t\t\t\t\t\t\t\t\t"]))),
            children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              variant: "h3",
              weight: "bolder",
              css: {
                marginTop: 32
              },
              children: translate("Your Account")
            }), profile && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              justifyContent: "space-between",
              onClick: openSwapAccountModal,
              style: (0, StyledComponents_1.accountLink)({
                color: multiAccount ? primaryBrand : secondaryBrand
              }),
              "data-testid": "my-account-menu-mobile-link",
              children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
                children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "md",
                  color: secondaryBrand,
                  css: {
                    marginRight: 10
                  },
                  children: getActiveProfile()[0].locationName
                }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                  size: "md",
                  color: secondaryBrand,
                  children: ["(", getActiveProfile()[0].locationNumber, ")"]
                })]
              })
            })]
          })]
        }), isMobile && (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
          color: darkGray
        }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          className: "menu-items-container",
          style: (0, StyledComponents_1.menuItemContainerStyles)(isMobile),
          children: [menuList.map(function (menuItem, index) {
            return renderMenuItem(menuItem, index);
          }), renderMenuItem(menuMoreButton, menuList.length), (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
            color: darkGray
          }), menuFooter.map(function (footerItem, index) {
            return okToRenderFooterItem(footerItem.id) && renderMenuItem(footerItem, index);
          })]
        })]
      })
    })
  });
};

exports.default = MyAccountMenu;